import React, { useState, useRef } from 'react';
import api from './api/client';
import * as XLSX from 'xlsx';
import HeaderLogged from './components/header_logged';
import DataTable from './components/DataTable';
import Container from './components/container';
import Tabs from './components/Tabs';
import TableTittle from './components/TableTittle';
import SearchAndFilter from './components/SearchAndFilter';
import Icons from './components/icons';
import Popup from './components/Popup';
import AddForm from './components/AddForm';
import KitPopup from './components/kits/KitPopup';
import SetPopup from './components/sets/SetPopup';
import WildmicrPopup from './components/sets/WildmicrPopup';
import FertProductPopup from './components/sets/FertProductPopup';
import ReadyProductPopup from './components/sets/ReadyProductPopup';
import FertRawMaterialPopup from './components/sets/FertRawMaterialPopup';
import BrandPopup from './components/sets/BrandPopup';
import ContainerPopup from './components/sets/ContainerPopup';
import SeedPopup from './components/sets/SeedPopup';
import IndividualPacketPopup from './components/sets/IndividualPacketPopup';
import BulkEditPopup from './components/BulkEditPopup';
import { usePermissions } from './PermissionsContext';
import { API_URL } from './config'

const GeneralPage = () => {
    const { can } = usePermissions();
    // Себестоимость видят только с правом finance (Epic 8 фаза 2);
    // сервер эти поля таким пользователям всё равно не отдаёт.
    const canSeeFinance = can('finance');
    const filtersConfig = {
        brands: [],
        seeds: [],
        individualpackets: [],
        sets: [],
        wildmicr: [],
        containers: [],
        readyproducts: [],
        fert_products: [],
        fert_raw_materials: [],
        niche_category: [],
        kits: [],
    };
    // Изменяем инициализацию состояния для хранения текущих значений фильтров
    const [filterParams, setFilterParams] = useState(() => {
        // Инициализируем фильтры с дефолтными значениями из filtersConfig
        const initialFilters = {};
        for (const tab in filtersConfig) {
            filtersConfig[tab].forEach(filter => {
                if (filter.defaultValue) {
                    initialFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        return initialFilters;
    });
    const setDefaultFilters = () => {
        const defaultFilters = {};
        if (Array.isArray(filtersConfig[activeTab])) {
            filtersConfig[activeTab].forEach(filter => {
                if (filter.defaultValue) {
                    defaultFilters[filter.field] = filter.defaultValue;
                }
            });
        }
        setFilterParams(defaultFilters);
    };
    const [searchTerm, setSearchTerm] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [popupFields, setPopupFields] = useState([]);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupSubtitle, setPopupSubtitle] = useState('');
    const [updateKey, setUpdateKey] = useState(0);
    const [activeTab, setActiveTab] = useState('brands'); // Default active tab
    const [data, setData] = useState([]); // Data for the active tab
    const tableRefs = useRef({}); // Reference for table elements
    const [isKitPopupOpen, setIsKitPopupOpen] = useState(false);
    const [kitEditData, setKitEditData] = useState(null);
    const [isSetPopupOpen, setIsSetPopupOpen] = useState(false);
    const [setEditData, setSetEditData] = useState(null);
    const [isWildmicrPopupOpen, setIsWildmicrPopupOpen] = useState(false);
    const [wildmicrEditData, setWildmicrEditData] = useState(null);
    const [isFertPopupOpen, setIsFertPopupOpen] = useState(false);
    const [fertEditData, setFertEditData] = useState(null);
    const [isReadyPopupOpen, setIsReadyPopupOpen] = useState(false);
    const [readyEditData, setReadyEditData] = useState(null);
    const [isFertRawPopupOpen, setIsFertRawPopupOpen] = useState(false);
    const [fertRawEditData, setFertRawEditData] = useState(null);
    const [isBrandPopupOpen, setIsBrandPopupOpen] = useState(false);
    const [brandEditData, setBrandEditData] = useState(null);
    const [isContainerPopupOpen, setIsContainerPopupOpen] = useState(false);
    const [containerEditData, setContainerEditData] = useState(null);
    const [isNichePopupOpen, setIsNichePopupOpen] = useState(false);
    const [nicheEditData, setNicheEditData] = useState(null);
    const [isSeedPopupOpen, setIsSeedPopupOpen] = useState(false);
    const [seedEditData, setSeedEditData] = useState(null);
    const [isIndPacketPopupOpen, setIsIndPacketPopupOpen] = useState(false);
    const [indPacketEditData, setIndPacketEditData] = useState(null);
    const [isBulkEditOpen, setIsBulkEditOpen] = useState(false);

    const keyFieldsConfig = {
        sets: 'SKU',
        brands: 'brandID',
        containers: 'containerID',
        seeds: 'seedsID',
        setscomposition: ['setSKU', 'sbSKU'],
        seedscategory: 'categoryID',
        employees: 'employeeID',
        emplphones: 'employeeID',
        empladdresses: 'employeeID',
        individualpackets: 'SKU',
        sbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        mbproduction: ['sku', 'emplID', 'prodDate', 'shift'],
        whlocations: 'location',
        seedslocationwh: 'seedsID',
        masterbagsinventory: 'sku',
        smallbagsinventory: 'sku',
        individualpacketsinventory: 'SKU',
        setsInventory: 'SKU',
        wildmicr: 'SKU',
        wildmicrinventory: 'SKU',
        readyproducts: 'SKU',
        wildmicrproduction: ['SKU', 'emplID', 'prodDate', 'shift'],
        wildmicrmasterbagsinventory: 'sku',
        minitoolsinventory: 'brandID',
        silicagelinventory: 'brandID',
        shipmentsfbamb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentsfbafb: ['brandID', 'shipmentID', 'SKU', 'shipmentDate'],
        shipmentssbss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentsssmb: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrss: ['brandID', 'SKU', 'shipmentDate'],
        shipmentswildmicrfba: ['brandID', 'shipmentID','SKU', 'shipmentDate'],
        workperformance: ['employeeID', 'workday', 'shift'],
        materialsuppliers: ['supplierID'],
        seedssuppliers: ['supplierID'],
        smallbagsorder: ['sku',	'orderDate'],
        masterbagsorder: ['sku','orderDate'],
        seedsorders: ['seedsID', 'supplierID', 'orderdate'],
        silicabagsorders: ['brandID', 'orderDate'],
        toolsorders: ['brandID', 'orderDate'],
        wmmasterbagsorder: ['sku','orderDate'],
        fert_raw_materials: 'id',
        fert_products: 'SKU',
        kits: 'SKU',
        niche_category: 'niche_category_id',
    };

    // Полные наборы полей для bulk-редактора — зеркалят попапы товаров
    // (SetPopup, IndividualPacketPopup и т.д.). Табы без записи здесь
    // используют tabs[].fields.
    const bulkImg = { label: 'Photo', name: '_image', type: 'image' };
    const bulkBrand = { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' };
    const bulkNiche = { label: 'Niche', name: 'niche_category_id', type: 'select', tableName: 'niche_category', displayField: 'niche_name', updateField: 'niche_category_id' };
    const bulkSeed = { label: 'Seed', name: 'seedsID', type: 'select', tableName: 'seeds', displayField: 'combinedSeedsName', displayFallback: 'seedsName', updateField: 'seedsID' };
    const bulkMkts = { label: 'Marketplaces', name: 'marketplaces', type: 'marketplaces' };
    const bulkActive = { label: 'Active', name: 'isActive', type: 'select', options: [{ value: '1', label: 'Yes' }, { value: '0', label: 'No' }] };
    // Фото упаковки + Case Details (общая таблица product_details, сохраняются отдельным PUT)
    const bulkPhotos = [
        { label: 'Front', name: '_image_front', type: 'image', kind: 'front' },
        { label: 'Back', name: '_image_back', type: 'image', kind: 'back' },
        { label: 'Side', name: '_image_side', type: 'image', kind: 'side' },
    ];
    const bulkDims = [
        { label: 'UPC', name: 'upc', details: true },
        { label: 'L (in)', name: 'length_in', details: true },
        { label: 'W (in)', name: 'width_in', details: true },
        { label: 'H (in)', name: 'height_in', details: true },
        { label: 'Weight', name: 'weight_value', details: true },
        { label: 'Weight Unit', name: 'weight_unit', type: 'select', details: true, options: [{ value: 'g', label: 'g' }, { value: 'lb', label: 'lb' }, { value: 'oz', label: 'oz' }] },
        { label: 'Box (L×W×H in)', name: 'box_size', details: true },
    ];
    const bulkFieldsConfig = {
        seeds: [
            { label: 'Category', name: 'seedsCategoryID', type: 'select', tableName: 'seedscategory', displayField: 'categoryName', updateField: 'categoryID' },
            { label: 'Name', name: 'seedsName' },
            { label: 'Variety Name', name: 'varietyName' },
            { label: 'Latin Name', name: 'varietyLatinName' },
            { label: 'Combined Name', name: 'combinedSeedsName' },
            { label: 'Seeds Per LB', name: 'seedsperlb' },
            // Себестоимость — только видящим деньги (Epic 8 фаза 2)
            ...(canSeeFinance ? [{ label: 'Cost/lb ($)', name: 'cost_per_pound' }] : []),
        ],
        individualpackets: [
            bulkImg, ...bulkPhotos,
            { label: 'Name', name: 'packName' },
            { label: 'ASIN', name: 'ASIN' },
            { label: 'FNSKU', name: 'FNSKU' },
            { label: 'GTIN', name: 'GTIN' },
            { label: 'Model Number', name: 'modelNumber' },
            bulkBrand,
            bulkSeed,
            { label: 'Seeds Per Packet', name: 'seedsperpacket' },
            { label: 'G Per Packet', name: 'gperpacket' },
            { label: 'Individual Sale', name: 'indSale', type: 'select', options: [{ value: 'YES', label: 'YES' }, { value: 'NO', label: 'NO' }] },
            { label: 'Bags per Box', name: 'bagsPerBox' },
            bulkNiche,
            bulkMkts,
            ...bulkDims,
        ],
        sets: [
            bulkImg, ...bulkPhotos,
            { label: 'Name', name: 'setmane' },
            { label: 'ASIN', name: 'ASIN' },
            { label: 'FNSKU', name: 'FNSKU' },
            { label: 'GTIN', name: 'GTIN' },
            bulkBrand,
            bulkNiche,
            { label: 'Bags per Box', name: 'bagsPerBox' },
            { label: 'Produce per Shift', name: 'produce_per_shift' },
            { label: 'WH Location', name: 'locationWH' },
            bulkActive,
            bulkMkts,
            ...bulkDims,
        ],
        wildmicr: [
            bulkImg, ...bulkPhotos,
            { label: 'Name', name: 'packName' },
            { label: 'ASIN', name: 'ASIN' },
            { label: 'FNSKU', name: 'FNSKU' },
            { label: 'GTIN', name: 'GTIN' },
            bulkBrand,
            bulkSeed,
            { label: 'Bags per Box', name: 'bagsPerBox' },
            { label: 'Pack Size (oz)', name: 'pack_size_oz' },
            { label: 'Seeds lb per Pack', name: 'seedslbperpack' },
            { label: 'Produce per Shift', name: 'produce_per_shift' },
            bulkActive,
            bulkNiche,
            bulkMkts,
            ...bulkDims,
        ],
        fert_products: [
            bulkImg, ...bulkPhotos,
            { label: 'Product Name', name: 'productName' },
            { label: 'ASIN', name: 'ASIN' },
            { label: 'FNSKU', name: 'FNSKU' },
            { label: 'GTIN', name: 'GTIN' },
            bulkBrand,
            { label: 'Volume (lb)', name: 'volumeLb' },
            { label: 'Bags per Box', name: 'bagsPerBox' },
            { label: 'Produce per Shift', name: 'produce_per_shift' },
            { label: 'Machine Packet', name: 'machine_packet', type: 'select', options: [{ value: '1', label: 'Yes' }, { value: '0', label: 'No' }] },
            { label: 'Fertilizer Type', name: 'rawMaterialID', type: 'select', tableName: 'fert_raw_materials', displayField: 'materialName', updateField: 'id' },
            bulkActive,
            bulkNiche,
            bulkMkts,
            ...bulkDims,
        ],
        readyproducts: [
            bulkImg, ...bulkPhotos,
            { label: 'Product Name', name: 'productName' },
            { label: 'ASIN', name: 'ASIN' },
            { label: 'FNSKU', name: 'FNSKU' },
            { label: 'GTIN', name: 'GTIN' },
            bulkBrand,
            { label: 'Units per Box', name: 'unitsPerBox' },
            bulkNiche,
            bulkMkts,
            ...bulkDims,
        ],
    };

    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);
    };

    const handleFilter = (params) => {
        setFilterParams(params);
        fetchTabData(`${API_URL}/api/${activeTab}`, params); // Adjust this if needed
    };
    

    const handleEdit = (tableName, data, fields, title, subtitle) => {
        const keyField = keyFieldsConfig[tableName];
        const id = data[keyField];
        const updatedFields = fields.map(field => ({
            ...field,
            value: data[field.name],
        }));
        console.log('Editing data:', data);
        console.log('Updated fields:', updatedFields);
        setPopupData({ ...data, tableName, id });
        setPopupFields(updatedFields);
        setPopupTitle(title);
        setPopupSubtitle(subtitle);
        setIsPopupOpen(true);
    };
    
    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
        setPopupFields([]);
    };

    const handlePopupSubmit = async (event) => {
        event.preventDefault();
        try {
            const updateData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});
    
            const tableName = popupData.tableName;
            const id = popupData.id;
    
            console.log('handlePopupSubmit popupData:', popupData);
            console.log('Sending updateData:', updateData);
            if (!id) {
                console.error('ID is undefined');
                return;
            }
    
            const response = await api.put(`/api/${tableName}/${id}`, updateData);
            console.log('Server response:', response.data);
            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error updating data:', error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };
    

    const handleFieldChange = (index, event) => {
        const newFields = [...popupFields];
        newFields[index].value = event.target.value;

        // Update popupData with the new value
        const updatedData = { ...popupData, [newFields[index].name]: event.target.value };
        setPopupFields(newFields);
        setPopupData(updatedData);
    };

    const handleKitEdit = (data) => {
        setKitEditData(data);
        setIsKitPopupOpen(true);
    };

    const handleSetEdit = (data) => {
        setSetEditData(data);
        setIsSetPopupOpen(true);
    };

    const handleWildmicrEdit = (data) => {
        setWildmicrEditData(data);
        setIsWildmicrPopupOpen(true);
    };

    const handleFertEdit = (data) => {
        setFertEditData(data);
        setIsFertPopupOpen(true);
    };

    const handleFertRawEdit = (data) => {
        setFertRawEditData(data);
        setIsFertRawPopupOpen(true);
    };

    const handleBrandEdit = (data) => {
        setBrandEditData(data);
        setIsBrandPopupOpen(true);
    };

    const handleContainerEdit = (data) => {
        setContainerEditData(data);
        setIsContainerPopupOpen(true);
    };

    const handleNicheEdit = (data) => {
        setNicheEditData(data);
        setIsNichePopupOpen(true);
    };

    const handleSeedEdit = (data) => {
        setSeedEditData(data);
        setIsSeedPopupOpen(true);
    };

    const handleIndPacketEdit = (data) => {
        setIndPacketEditData(data);
        setIsIndPacketPopupOpen(true);
    };

    const handleReadyEdit = (data) => {
        setReadyEditData(data);
        setIsReadyPopupOpen(true);
    };

    const handleAddClick = () => {
        if (activeTab === 'kits') {
            setKitEditData(null);
            setIsKitPopupOpen(true);
            return;
        }
        if (activeTab === 'sets') {
            setSetEditData(null);
            setIsSetPopupOpen(true);
            return;
        }
        if (activeTab === 'wildmicr') {
            setWildmicrEditData(null);
            setIsWildmicrPopupOpen(true);
            return;
        }
        if (activeTab === 'fert_products') {
            setFertEditData(null);
            setIsFertPopupOpen(true);
            return;
        }
        if (activeTab === 'readyproducts') {
            setReadyEditData(null);
            setIsReadyPopupOpen(true);
            return;
        }
        if (activeTab === 'fert_raw_materials') {
            setFertRawEditData(null);
            setIsFertRawPopupOpen(true);
            return;
        }
        if (activeTab === 'brands') {
            setBrandEditData(null);
            setIsBrandPopupOpen(true);
            return;
        }
        if (activeTab === 'containers') {
            setContainerEditData(null);
            setIsContainerPopupOpen(true);
            return;
        }
        if (activeTab === 'niche_category') {
            setNicheEditData(null);
            setIsNichePopupOpen(true);
            return;
        }
        if (activeTab === 'seeds') {
            setSeedEditData(null);
            setIsSeedPopupOpen(true);
            return;
        }
        if (activeTab === 'individualpackets') {
            setIndPacketEditData(null);
            setIsIndPacketPopupOpen(true);
            return;
        }
        const fields = tabs.find(tab => tab.name === activeTab).fields.map(field => ({
            ...field,
            value: ''
        }));
        setPopupData({ tableName: activeTab });
        setPopupFields(fields);
        setPopupTitle(`Add New ${activeTab}`);
        setPopupSubtitle(`Add new ${activeTab} details`);
        setIsPopupOpen(true);
    };

    const handleAddSubmit = async (event) => {
        event.preventDefault();
        try {
            const newData = popupFields.reduce((acc, field) => {
                acc[field.name] = field.value;
                return acc;
            }, {});

            const tableName = popupData.tableName;

            console.log('handleAddSubmit newData:', newData); // Debugging line
            const response = await api.post(`/api/${tableName}`, newData);
            console.log('Server response:', response.data); // Debugging line
            handleClosePopup();
            setUpdateKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error adding data:', error);
            if (error.response) {
                console.error('Server responded with:', error.response.data);
            }
        }
    };

    const fetchTabData = async (endpoint) => {
        try {
            const response = await api.get(endpoint, {
                params: {
                    page: 1,
                    limit: 100, // Set a large limit to get all data
                    search: searchTerm,
                    ...filterParams
                }
            });
            console.log('Fetched Data:', response.data); // Debugging line
            setData(response.data.items);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }
    };

    const tabs = [
        {
            name: 'brands',
            label: 'Brands',
            fields: [
                { label: 'Brand ID', name: 'brandID', type: 'text' },
                { label: 'Brand Name', name: 'brandName', type: 'text' }
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID', key: 'brandID' },
                        { label: 'Brand Name', key: 'brandName' },
                    ]}
                    endpoint={`${API_URL}/api/brands`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleBrandEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },
         {
            name: 'containers',
            label: 'Containers',
            fields: [
                { label: 'Container ID', name: 'containerID', type: 'text' },
                { label: 'Container Name', name: 'containerName', type: 'text' },
                { label: 'Container Weight', name: 'containerWeight', type: 'text' },
                { label: 'Container Weight Measure', name: 'containerWeightMeasure', type: 'text' }
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID', key: 'containerID' },
                        { label: 'Name', key: 'containerName' },
                        { label: 'Weight', key: 'containerWeight' },
                        { label: 'Weight Measure', key: 'containerWeightMeasure' },
                    ]}
                    endpoint={`${API_URL}/api/containers`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleContainerEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },

        {
            name: 'seeds',
            label: 'Seeds Catalog',
            fields: [
                { label: 'ID', name: 'seedsID', type: 'text' },
                { label: 'Category', name: 'seedsCategoryID', type: 'select', tableName: 'seedscategory', displayField: 'categoryName', updateField: 'categoryID' },
                { label: 'Name', name: 'seedsName', type: 'text' },
                { label: 'Variety Name', name: 'varietyName', type: 'text' },
                { label: 'Latin Name', name: 'varietyLatinName', type: 'text' },
                { label: 'Seeds Per LB', name: 'seedsperlb', type: 'text' },
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID', key: 'seedsID' },
                        { label: 'Category', key: 'categoryName' },
                        { label: 'Name', key: 'seedsName' },
                        { label: 'Variety Name', key: 'varietyName' },
                        { label: 'Latin Name', key: 'varietyLatinName' },
                        { label: 'Seeds Per LB', key: 'seedsperlb' },
                        ...(canSeeFinance ? [{ label: 'Cost/lb ($)', key: 'cost_per_pound' }] : []),
                    ]}
                    endpoint={`${API_URL}/api/seeds`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleSeedEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            )
        },
            
        {
            name: 'individualpackets',
            label: 'Individual Packets List',
            fields: [
                { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' },
                { label: 'SKU', name: 'SKU', type: 'text' },
                { label: 'GTIN', name: 'GTIN', type: 'text' },
                { label: 'Name', name: 'packName', type: 'text' },
                { label: 'Individual Sale', name: 'indSale', type: 'text' },
                { label: 'G Per Packet', name: 'gperpacket', type: 'text' },
                { label: 'Seeds Per Packet', name: 'seedsperpacket', type: 'text'},
                { label: 'Bags per Box', name: 'bagsPerBox', type: 'text' },
                
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: '', key: '_image', type: 'image' },
                        { label: 'Brand', key: 'brandName' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'GTIN', key: 'GTIN' },
                        { label: 'Name', key: 'packName' },
                        { label: 'Seeds Per Packet', key: 'seedsperpacket' },
                        { label: 'G Per Packet', key: 'gperpacket' },
                        { label: 'Individual Sale', key: 'indSale'},
                        { label: 'Bags per Box', key: 'bagsPerBox' },
                    ]}
                    endpoint={`${API_URL}/api/individualpackets`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleIndPacketEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },
        
        {
            name: 'sets',
            label: 'Sets List',
            fields: [
                { label: 'SKU', name: 'SKU', type: 'text' },
                { label: 'ASIN', name: 'ASIN', type: 'text' },
                { label: 'GTIN', name: 'GTIN', type: 'text' },
                { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' },
                { label: 'Name', name: 'setmane', type: 'text' },
                { label: 'Bags per Box', name: 'bagsPerBox', type: 'text' },
                { label: 'Location', name: 'locationWH', type: 'text'},
                { label: 'Produce per Shift', name: 'produce_per_shift', type: 'text' }
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: '', key: '_image', type: 'image' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'ASIN', key: 'ASIN' },
                        { label: 'GTIN', key: 'GTIN' },
                        { label: 'Brand', key: 'brandName' },
                        { label: 'Name', key: 'setmane' },
                        { label: 'Bags per Box', key: 'bagsPerBox' },
                        { label: 'WH Lot', key: 'locationWH' },
                        { label: 'Produce per Shift', key: 'produce_per_shift' },
                    ]}
                    endpoint={`${API_URL}/api/sets`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleSetEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },

        {
            name: 'wildmicr',
            label: 'Wildflowers & Microgreens List',
            fields: [
                { label: 'SKU', name: 'SKU', type: 'text' },
                { label: 'ASIN', name: 'ASIN', type: 'text' },
                { label: 'GTIN', name: 'GTIN', type: 'text' },
                { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' },
                { label: 'Name', name: 'packName', type: 'text' },
                { label: 'Bags per Box', name: 'bagsPerBox', type: 'text' },
                { label: 'Produce per Shift', name: 'produce_per_shift', type: 'text' }
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: '', key: '_image', type: 'image' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'ASIN', key: 'ASIN' },
                        { label: 'GTIN', key: 'GTIN' },
                        { label: 'Brand', key: 'brandName' },
                        { label: 'Name', key: 'packName' },
                        { label: 'Bags per Box', key: 'bagsPerBox' },
                        { label: 'Produce per Shift', key: 'produce_per_shift' },
                    ]}
                    endpoint={`${API_URL}/api/wildmicr`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleWildmicrEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },

       
        {
            name: 'readyproducts',
            label: 'Ready Products',
            fields: [
                { label: 'SKU', name: 'SKU', type: 'text' },
                { label: 'ASIN', name: 'ASIN', type: 'text' },
                { label: 'GTIN', name: 'GTIN', type: 'text' },
                { label: 'Product Name', name: 'productName', type: 'text' },
                { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' },
                { label: 'Units per Box', name: 'unitsPerBox', type: 'text' },
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: '', key: '_image', type: 'image' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'ASIN', key: 'ASIN' },
                        { label: 'GTIN', key: 'GTIN' },
                        { label: 'Product Name', key: 'productName' },
                        { label: 'Brand', key: 'brandName' },
                        { label: 'Units per Box', key: 'unitsPerBox' },
                    ]}
                    endpoint={`${API_URL}/api/readyproducts`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleReadyEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },

        {
            name: 'fert_products',
            label: 'Fertilizers',
            fields: [
                { label: 'SKU', name: 'SKU', type: 'text' },
                { label: 'ASIN', name: 'ASIN', type: 'text' },
                { label: 'GTIN', name: 'GTIN', type: 'text' },
                { label: 'Brand', name: 'brandID', type: 'select', tableName: 'brands', displayField: 'brandName', updateField: 'brandID' },
                { label: 'Product Name', name: 'productName', type: 'text' },
                { label: 'Volume (lb)', name: 'volumeLb', type: 'text' },
                { label: 'Bags per Box', name: 'bagsPerBox', type: 'text' },
                { label: 'Produce per Shift', name: 'produce_per_shift', type: 'text' },
                { label: 'Fertilizer Type', name: 'rawMaterialID', type: 'select', tableName: 'fert_raw_materials', displayField: 'materialName', updateField: 'id' },
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: '', key: '_image', type: 'image' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'ASIN', key: 'ASIN' },
                        { label: 'GTIN', key: 'GTIN' },
                        { label: 'Brand', key: 'brandName' },
                        { label: 'Product Name', key: 'productName' },
                        { label: 'Volume (lb)', key: 'volumeLb' },
                        { label: 'Bags per Box', key: 'bagsPerBox' },
                        { label: 'Produce per Shift', key: 'produce_per_shift' },
                        { label: 'Fertilizer Type', key: 'materialName' },
                    ]}
                    endpoint={`${API_URL}/api/fert_products`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleFertEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },

        {
            name: 'fert_raw_materials',
            label: 'Fertilizer Types',
            fields: [
                { label: 'Material Name', name: 'materialName', type: 'text' },
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID', key: 'id' },
                        { label: 'Material Name', key: 'materialName' },
                    ]}
                    endpoint={`${API_URL}/api/fert_raw_materials`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleFertRawEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },

        {
            name: 'niche_category',
            label: 'Niches',
            fields: [
                { label: 'Niche Name', name: 'niche_name', type: 'text' },
            ],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: 'ID',   key: 'niche_category_id' },
                        { label: 'Name', key: 'niche_name' },
                    ]}
                    endpoint={`${API_URL}/api/niche_category`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleNicheEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },

        {
            name: 'kits',
            label: 'Kits',
            fields: [],
            content: (
                <DataTable
                    key={updateKey}
                    title=""
                    columns={[
                        { label: '', key: '_image', type: 'image' },
                        { label: 'SKU', key: 'SKU' },
                        { label: 'Name', key: 'name' },
                        { label: 'ASIN', key: 'ASIN' },
                        { label: 'GTIN', key: 'GTIN' },
                        { label: 'Brand', key: 'brandName' },
                        { label: 'Components', key: 'component_count' },
                    ]}
                    endpoint={`${API_URL}/api/kits`}
                    searchTerm={searchTerm}
                    filterParams={filterParams}
                    onEdit={(data) => handleKitEdit(data)}
                    keyFieldsConfig={keyFieldsConfig}
                    onFetchData={fetchTabData}
                />
            ),
        },
    ];

    return (
        <>
            <Icons />
            <HeaderLogged />
            <Container>
                <TableTittle
                    sectionTitle="General"
                    sectionSubtitle="Manage general details"
                    onAddClick={handleAddClick}
                    activeTab={activeTab}
                    tableRefs={tableRefs}
                    onBulkEditClick={(bulkFieldsConfig[activeTab] || tabs.find(tab => tab.name === activeTab)?.fields)?.length ? () => setIsBulkEditOpen(true) : undefined}
                />
                <SearchAndFilter
                    placeholder="Search by date, employee name, seeds..."
                    onSearch={handleSearch}
                    onFilter={handleFilter}
                    filtersConfig={filtersConfig[activeTab] || []}
                    
                />
                <Tabs 
                    tabs={tabs} 
                    activeTab={activeTab} 
                    setActiveTab={setActiveTab} 
                    tableRefs={tableRefs}
                />
            </Container>
            <BulkEditPopup
                isOpen={isBulkEditOpen}
                onClose={() => setIsBulkEditOpen(false)}
                tableName={activeTab}
                endpoint={`${API_URL}/api/${activeTab}`}
                fields={bulkFieldsConfig[activeTab] || tabs.find(tab => tab.name === activeTab)?.fields || []}
                keyField={keyFieldsConfig[activeTab]}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            {popupData && (
                <Popup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    title={popupTitle}
                    subtitle={popupSubtitle}
                    fields={popupFields}
                    onFieldChange={handleFieldChange}
                    onSubmit={popupData.id ? handlePopupSubmit : handleAddSubmit}
                />
            )}
            <KitPopup
                isOpen={isKitPopupOpen}
                onClose={() => setIsKitPopupOpen(false)}
                editData={kitEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <SetPopup
                isOpen={isSetPopupOpen}
                onClose={() => setIsSetPopupOpen(false)}
                editData={setEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <WildmicrPopup
                isOpen={isWildmicrPopupOpen}
                onClose={() => setIsWildmicrPopupOpen(false)}
                editData={wildmicrEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <FertProductPopup
                isOpen={isFertPopupOpen}
                onClose={() => setIsFertPopupOpen(false)}
                editData={fertEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <ReadyProductPopup
                isOpen={isReadyPopupOpen}
                onClose={() => setIsReadyPopupOpen(false)}
                editData={readyEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <FertRawMaterialPopup
                isOpen={isFertRawPopupOpen}
                onClose={() => setIsFertRawPopupOpen(false)}
                editData={fertRawEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <BrandPopup
                isOpen={isBrandPopupOpen}
                onClose={() => setIsBrandPopupOpen(false)}
                editData={brandEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <ContainerPopup
                isOpen={isContainerPopupOpen}
                onClose={() => setIsContainerPopupOpen(false)}
                editData={containerEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <SeedPopup
                isOpen={isSeedPopupOpen}
                onClose={() => setIsSeedPopupOpen(false)}
                editData={seedEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <IndividualPacketPopup
                isOpen={isIndPacketPopupOpen}
                onClose={() => setIsIndPacketPopupOpen(false)}
                editData={indPacketEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
            />
            <FertRawMaterialPopup
                isOpen={isNichePopupOpen}
                onClose={() => setIsNichePopupOpen(false)}
                editData={nicheEditData}
                onSaved={() => setUpdateKey(k => k + 1)}
                addEndpoint="/api/niches-batch"
                editEndpoint="/api/niches-batch"
                idField="niche_category_id"
                nameField="niche_name"
                addTitle="Add Niches"
                editTitle="Edit Niche"
                addSubtitle="Enter one or more niche names — press Enter to add a row"
                icon="fas fa-layer-group"
                placeholder="e.g. Carrots"
            />
        </>
    );
};

export default GeneralPage;
